var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcn34(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5H2C1.724 7.5 1.5 7.276 1.5 7V5.5C1.5 5.224 1.724 5 2 5H2.5V7.5ZM10.5 5.5H5.5V7H10.5V5.5ZM11.5 5V7.5C11.5 7.7755 11.2755 8 11 8H5C4.7245 8 4.5 7.7755 4.5 7.5V5C4.5 4.7245 4.7245 4.5 5 4.5H11C11.2755 4.5 11.5 4.7245 11.5 5ZM11 5H5V7.5H11V5ZM13 9.01C13 9.6685 12.935 10.3255 12.806 10.971L12.2415 13.794C12.101 14.4955 11.4855 15 10.7705 15H5.2295C4.5145 15 3.899 14.4955 3.7585 13.794L3.194 10.971C3.065 10.325 3 9.6685 3 9.01V3.5C3 2.1195 4.1195 1 5.5 1H10.5C11.8805 1 13 2.1195 13 3.5V9.01ZM12 5C12 4.4485 11.5515 4 11 4H5C4.4485 4 4 4.4485 4 5V7.5C4 8.0515 4.4485 8.5 5 8.5H11C11.5515 8.5 12 8.0515 12 7.5V5ZM14 5H13.5V7.5H14C14.276 7.5 14.5 7.276 14.5 7V5.5C14.5 5.224 14.276 5 14 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcn34);
export default __webpack_public_path__ + "static/media/CCN34.2c05a85ad16597991216aee95bc27632.svg";
export { ForwardRef as ReactComponent };